<template>
  <div :class="cmp_class">
    <div class="mb-2">
        <div class="d-flex justify-space-between">
            <div class="text-left">
                <div class="widget-num-text">{{num_text}}</div>
                 <div class="widget-sub-text">{{sub_text}}</div>
            </div>
            <div>
                <v-icon large>{{icon}}</v-icon>
            </div>
        </div>
        <div class="text-left widget-main-text">
            {{main_text}}
        </div>
    </div>
    <v-divider></v-divider>
    <v-btn
      block
      small
      text
      :disabled="is_loading"
      color="primary"
      class="mt-2"
      :to="link"
    >
      Go To View List
      <v-icon right>mdi-arrow-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "DasboardBoxWidget",
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    color: {
        type: String,
        default: "success"
    },
    sub_text: {
        type: String,
        default: ""
    },
    main_text: {
        type: String,
        default: ""
    },
    num_text: {
        type: String,
        default: ""
    },
    link: {
        type: String,
        default: ""
    },
    icon: {
        type: String,
        default: "mdi-bell"
    },
  },
  computed:{
      cmp_class(){
          var cls = this.color + " lighten-1 pa-2 ma-2 round-4 elevation-4 ";
          return cls;
      }
  }
};
</script>